/**
 * Zoom image control
 *
 * Handles toggling the zoom onclick.
 */

(function($) {

    // $('.zoom-image').zoom( { on:"click" } );

})